module.exports = __webpack_public_path__ + "static/media/296733.6ddc81c1.png";